import React from 'react';
import PropTypes from 'prop-types';

import './Instructions.scss';

const Instructions = ({ instructions }) => (
  <div className="instructions">
    <img src={require('../../images/indicator.svg')} alt="i" />
    <div className="instruction">{instructions.map((instruction, index) => <div key={index}>{instruction}</div>)}</div>
  </div>
);

Instructions.propType = {
  instructions: PropTypes.array,
};

Instructions.defaultProps = {
  instructions: [],
};

export default Instructions;
